import Footer from "../../components/footer/footer"
import Header from "../../components/header/header"
import LoginSection from "../../components/provider_login/login";
import SearchModel from "../../components/search_model/search";

const ProviderLogin = () => {
    return (
        <>
            <Header />
            <LoginSection/>
            <Footer />
            <SearchModel/>
        </>
    )
}

export default ProviderLogin